"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var nextUniqueId = 0;
function getNextUniqueId() {
    return nextUniqueId++;
}
exports.default = getNextUniqueId;



//////////////////
// WEBPACK FOOTER
// ./node_modules/dnd-core/lib/cjs/utils/getNextUniqueId.js
// module id = 1017
// module chunks = 0